/**
 * @desc 根据加密手机/token获取手机号
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** token */
  token: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(`/storeapi/api/v1/store/phone`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
